import { render, staticRenderFns } from "./Accesos.vue?vue&type=template&id=5170cbe1&"
import script from "./Accesos.vue?vue&type=script&lang=js&"
export * from "./Accesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports